import React, { Component } from 'react'
import { SINGLE_ORDER_MAX_NUM } from '../../../common/saleConfig'

const Addition = ({value,maxValue,changeValue,sellout})=>{
    const buttonForbidden = value>=maxValue
    const clickHandler = ()=>{
        !sellout && !buttonForbidden && changeValue(++value)
    }
    return  <em className={(buttonForbidden||sellout)?'np-add np-num-disable':'np-add'} onClick={clickHandler}>+</em>
}
const Subtraction = ({value,minValue,changeValue,sellout})=>{
    const buttonForbidden = value<=minValue
    const clickHandler = ()=>{
        !sellout && !buttonForbidden && changeValue(--value)
    }
    return <em className={(value<=minValue||sellout)?'np-minus np-num-disable':'np-minus'} onClick={clickHandler}>-</em>
}

function createCounter(type, min, max) {
    return class DiskCount extends Component {
        constructor(props){
            super(props)
            this.state = {
                min,
                max,
                type
            }
            this.changeHandler = this.changeHandler.bind(this)
        }
        changeHandler(e){
            const {changeShoppingList} = this.props;
            const {min,max,type} = this.state;
            const changeHandlerInDiskCount = changeShoppingList.bind(null,type)
            const newValue = e.target.value;
            if(newValue<min){
                changeHandlerInDiskCount(min)
            }else if(newValue>max){
                changeHandlerInDiskCount(max)
            }else {
                changeHandlerInDiskCount(newValue)
            }
        }
        render(){
            const {value,changeShoppingList,sellout} = this.props;
            const {min,max} = this.state;
            const changeHandlerByType = changeShoppingList.bind(null,type)
            return <div className="np-select-item-num">
                <Subtraction value={value} minValue={min} changeValue={changeHandlerByType} sellout={sellout}/>
                <input type="number" value={value} onChange={this.changeHandler} disabled={sellout}/>
                <Addition value={value} maxValue={max} changeValue={changeHandlerByType} sellout={sellout}/>
            </div>
        }
    }
}

export const DiskCounterInEnterprise = createCounter('diskCount',0,50000)
export const OrangeCounterInEnterprise = createCounter('orange',0,50000)
export const BlackCounterInEnterprise = createCounter('black',0,50000)
export const BlueCounterInEnterprise = createCounter('blue',0,50000)
export const DiskCounterInOpensale = createCounter('diskCount',0,150)
export const OrangeCounterInOpensale = createCounter('orange', 0, SINGLE_ORDER_MAX_NUM)
export const BlackCounterInOpensale = createCounter('black', 0, SINGLE_ORDER_MAX_NUM)
export const BlueCounterInOpensale = createCounter('blue', 0, SINGLE_ORDER_MAX_NUM)


// WEBPACK FOOTER //
// ./js/src/pages/Purchase/components/counter.jsx